import { TokenResponse } from '@sanlam-glacier/app-common/types/auth/token-response.type.js';
import { UserInfo } from '@sanlam-glacier/app-common/types/auth/user-info.type.js';
import { AES, enc } from 'crypto-js';

const SESSION_CODE_VERIFIER = 'codeVerifier';
const SESSION_AUTH_IDENTIFIER = 'userIdentifier';
const SESSION_USER_INFO = 'userinfo';
const SESSION_USER_ENCRYPTION_KEY = 'oECxJUhXnNRWENON';

export const AuthStore = {
  getCodeVerifier: (): string | undefined => {
    const verifier = sessionStorage.getItem(SESSION_CODE_VERIFIER);
    if (!verifier) return undefined;
    return verifier;
  },
  setCodeVerifier: (verifier: string | undefined) => {
    if (!verifier) {
      sessionStorage.removeItem(SESSION_CODE_VERIFIER);
      return;
    }
    sessionStorage.setItem(SESSION_CODE_VERIFIER, verifier);
  },
  getAuthToken: (): TokenResponse | undefined => {
    const authToken = sessionStorage.getItem(SESSION_AUTH_IDENTIFIER);
    if (!authToken) return undefined;
    const parsedToken: TokenResponse = JSON.parse(authToken);
    parsedToken.token_expiry_time = new Date(parsedToken.token_expiry_time); // TODO find better way to parse date ISO strings to Date objects
    return parsedToken;
  },
  setAuthToken: (authToken: TokenResponse | undefined) => {
    if (!authToken) {
      sessionStorage.removeItem(SESSION_AUTH_IDENTIFIER);
      return;
    }
    sessionStorage.setItem(SESSION_AUTH_IDENTIFIER, JSON.stringify(authToken));
  },
  getUserInfo: (): UserInfo | undefined => {
    const userInfo = sessionStorage.getItem(SESSION_USER_INFO);
    if (!userInfo) return undefined;
    const decryptUserInfo = AES.decrypt(userInfo, SESSION_USER_ENCRYPTION_KEY).toString(enc.Utf8);
    if (!decryptUserInfo) {
      sessionStorage.removeItem(SESSION_USER_INFO);
      return;
    }
    return JSON.parse(decryptUserInfo);
  },
  setUserInfo: (userInfo: UserInfo | undefined) => {
    if (!userInfo) {
      sessionStorage.removeItem(SESSION_USER_INFO);
      return;
    }
    const encryptUserInfo = AES.encrypt(
      JSON.stringify(userInfo),
      SESSION_USER_ENCRYPTION_KEY
    ).toString();
    sessionStorage.setItem(SESSION_USER_INFO, encryptUserInfo);
  }
};
